<template>
	<div
		class="p-6 transition-all duration-500 border shadow-xl sm:p-8 lg:p-10 sm:shadow-2xl bg-white/90 backdrop-blur-md rounded-2xl sm:rounded-3xl border-white/40 hover:shadow-blue-500/10 animate-fade-in-up"
	>
		<div class="mb-6 text-center sm:mb-8">
			<h2 class="mb-3 text-2xl font-bold sm:text-3xl text-slate-900">
				Enter Commercial Vehicle Details
			</h2>
			<p class="max-w-2xl mx-auto text-base sm:text-lg text-slate-600">
				Please provide the details of the commercial vehicle you wish to
				insure
			</p>
		</div>
		<form
			@submit.prevent="submitDetails"
			class="grid max-w-2xl grid-cols-1 gap-4 mx-auto sm:gap-5 md:grid-cols-2"
		>
			<div>
				<label
					for="make"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Make:</label
				>
				<input
					type="text"
					id="make"
					v-model="localVehicleDetails.make"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div>
				<label
					for="model"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Model:</label
				>
				<input
					type="text"
					id="model"
					v-model="localVehicleDetails.model"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div>
				<label
					for="regNo"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Registration Number:</label
				>
				<input
					type="text"
					id="regNo"
					v-model="localVehicleDetails.registrationNumber"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div>
				<label
					for="chassisNo"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Chassis Number:</label
				>
				<input
					type="text"
					id="chassisNo"
					v-model="localVehicleDetails.chassisNumber"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div>
				<label
					for="engineNo"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Engine Number:</label
				>
				<input
					type="text"
					id="engineNo"
					v-model="localVehicleDetails.engineNumber"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div>
				<label
					for="engineCapacity"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Engine Capacity (CC):</label
				>
				<input
					type="number"
					id="engineCapacity"
					v-model.number="localVehicleDetails.engineCapacity"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div>
				<label
					for="bodyType"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Body Type:</label
				>
				<input
					type="text"
					id="bodyType"
					v-model="localVehicleDetails.bodyType"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div>
				<label
					for="fuelType"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Fuel Type:</label
				>
				<input
					type="text"
					id="fuelType"
					v-model="localVehicleDetails.fuelType"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div class="md:col-span-2">
				<label
					for="purpose"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Purpose of Use:</label
				>
				<input
					type="text"
					id="purpose"
					v-model="localVehicleDetails.purpose"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
					placeholder="e.g., General Cartage, Passenger Transport"
				/>
			</div>
			<div class="md:col-span-2">
				<label
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Have you made any changes to manufacturer's design of body
					or engine?</label
				>
				<div class="flex items-center gap-4">
					<label class="inline-flex items-center">
						<input
							type="radio"
							v-model="localVehicleDetails.modifications"
							value="yes"
							required
							class="text-blue-600 form-radio"
						/>
						<span class="ml-2 text-gray-700">Yes</span>
					</label>
					<label class="inline-flex items-center">
						<input
							type="radio"
							v-model="localVehicleDetails.modifications"
							value="no"
							required
							class="text-blue-600 form-radio"
						/>
						<span class="ml-2 text-gray-700">No</span>
					</label>
				</div>
			</div>

			<div
				class="flex flex-col-reverse justify-between col-span-2 gap-4 mt-6 sm:flex-row sm:mt-8"
			>
				<button
					@click="previous"
					type="button"
					class="w-full px-6 py-3 text-base font-semibold text-blue-600 transition-colors duration-300 border-2 border-blue-600 rounded-full sm:w-auto sm:text-lg hover:bg-blue-50"
				>
					Back
				</button>
				<button
					type="submit"
					class="w-full px-6 py-3 text-base font-semibold text-white transition-colors duration-300 bg-blue-600 rounded-full shadow-lg sm:w-auto sm:text-lg hover:bg-blue-700"
				>
					Continue
				</button>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	name: 'CommercialVehicleDetailsForm',
	data() {
		return {
			localVehicleDetails: {
				make: '',
				model: '',
				registrationNumber: '',
				chassisNumber: '',
				engineNumber: '',
				engineCapacity: null,
				bodyType: '',
				fuelType: '',
				purpose: '',
				modifications: null,
			},
		};
	},
	methods: {
		submitDetails() {
			// API call or logic to submit details
			this.$emit('next', { vehicleDetails: this.localVehicleDetails });
		},
		previous() {
			this.$emit('previous');
		},
	},
};
</script>

<style scoped>
/* Scoped styles for this component */
</style>
